import React, { useEffect, useState } from 'react'
import { EmailForm, ResendOtpButton, SubmitButton, TimerText } from "./styles"
import Input from "../Forms/Input"
import { useDispatch, useSelector } from 'react-redux';
import { validateEmailConfirmationForm } from '../../utils/formVerifications';
import { userLogin } from '../../store/user';

export default function EmailConfirmationForm({disabled}){
    const TIMER_INITIAL_VALUE = 45
    const dispatch = useDispatch();
    const {validUserEmail} = useSelector(state => state.auth.data)
    const emailRef = React.useRef(null);
    const [tokenInput, setTokenInput] = useState('');

    let interval
    const [timer, setTimer] = useState(TIMER_INITIAL_VALUE);

    const seconsdsToTimeDisplay = (time) => {
        const minutes = Math.floor(time/60);
        const seconds = time - (minutes * 60);

        return `${minutes.toString().padStart(2,'0')}:${seconds.toString().padStart(2,'0')}`
    }

    const handleEmailConfirmSubmit = async () => {
        const data = {
            tokenOtp: tokenInput
        }
        
        const emailFormValidation = await validateEmailConfirmationForm(data);

        if(emailFormValidation.payload){
          const {tokenOtp} = emailFormValidation.payload
          
          if(tokenOtp){
            const loginData = {
              email: validUserEmail,
              tokenOtp: tokenOtp.toString()
            }
                  
            dispatch(userLogin(loginData))
          }
        }else if (emailFormValidation.error){
          emailRef.current.setErrors(emailFormValidation.error)
        }
    }

    const updateTimer = () => {
        interval = !interval && setInterval(() => {
            setTimer(prevTimer => prevTimer > 1? prevTimer - 1 : 0)
        }, 1000)

        if(timer <= 0){
            clearInterval(interval)
        }
    }

    const resetTimer = () => {
        setTimer(TIMER_INITIAL_VALUE)
    }

    const handleResendOtp = async () => {
        // const response = await dispatch(authHttpRequest({
        //     url: '/auth/resendOtp', //TODO CONFIRM ROUTE // Aguardando implementação do backend
        //     method: 'POST',
        //     data: {
        //         email: validUserEmail
        //     }
        // }))

        resetTimer()
    }

    const handleTokenInputChenge = (event) => {
        const {value} = event.target;
        setTokenInput(value)
    }

    useEffect(()=>{
        updateTimer()

        return () => clearInterval(interval)
    },[timer])

    return(
        <>
            <EmailForm ref={emailRef} autoComplete="off" onSubmit={handleEmailConfirmSubmit}>
            <h1>Autenticação de dois fatores</h1>
            <p>Um e-mail foi enviado para <span>{validUserEmail}</span> com o código para a autenticação. Por favor, insira abaixo.</p>
            <Input onChange={handleTokenInputChenge} defaultValue="" name="tokenOtp" label="Código de verificação: *"/>
            
            <SubmitButton type="submit" disabled={disabled}>
                Entrar
            </SubmitButton>

            </EmailForm>

            <TimerText>{`O código expira em ${seconsdsToTimeDisplay(timer)} minutos`}</TimerText>

            <ResendOtpButton type="button" disabled={timer>0} onClick={handleResendOtp}>Reenviar código</ResendOtpButton>
        </>
    )
}